define('GameDayCore/GDModel/ValueObjects/Gamecenter/GamecenterPlaybackScenario',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(GamecenterPlaybackScenario);

	function GamecenterPlaybackScenario($data) {
		var vo = VO.ensureVO(this, GamecenterPlaybackScenario),
			data = $data;

		vo.speed = data.speed;
		vo.fid = data.fid;
		vo.w_id = data.w_id;
		vo.id = data.id;
		vo.authorization = data.authorization;
		vo.login = data.login;
		vo.type = data.type;
		vo.gid = data.gid;
		vo.pid = data.pid;
		vo.spons = data.spons;
		vo.vid = data.vid;
		vo.c_url = data.c_url;
		vo.mid = data.mid;
		vo.v = data.v;
		vo.state = data.state;
		vo.url = data._text;
	}

	return GamecenterPlaybackScenario;
});
